import { render, staticRenderFns } from "./RecordInterview.vue?vue&type=template&id=1f6cf46c&scoped=true&"
import script from "./RecordInterview.vue?vue&type=script&lang=ts&"
export * from "./RecordInterview.vue?vue&type=script&lang=ts&"
import style0 from "./RecordInterview.vue?vue&type=style&index=0&id=1f6cf46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6cf46c",
  null
  
)

export default component.exports